export default "__VITE_ASSET__7enMOVMv__"